module.exports = __webpack_public_path__ + "static/img/scene01.dbdc1b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene01.png
// module id = 6Zkv
// module chunks = 1